// TODO: Rename to Project for consistency with scripts
export enum Product {
  purposeful = 'purposeful',
  resourceful = 'resourceful',
  insightful = 'insightful',
}
